<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<mat-sidenav-container>
  <mat-sidenav #rulesSidenav position="end" mode="over" class="rules-sidenav" aria-label="Rules panel">
    <div class="rules-header">
      <label class="title">Rules in {{ selectedCollection?.name }} </label>
      <button mat-icon-button (click)="rulesSidenav.close()" aria-label="Close rules panel">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="rules-content">
      <mat-tab-group class="admin-tabs" animationDuration="0ms">
        <mat-tab>
          <ng-template mat-tab-label>
            <label class="labelHeading">
              Existing Rules
              @if (filteredForwardingRulesList.length > 0) {
                ({{ filteredForwardingRulesList.length }})
              }
            </label>
          </ng-template>
          <ng-template matTabContent>
            <div class="tab-content-container">
              @for (rule of filteredForwardingRulesList; track $index) {
                <mat-card appearance="outlined">
                  <mat-card-header>
                    <mat-card-title>{{ rule.name }}</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                    <div class="rule-condition">
                      <div class="rule-conditions-container">
                        @for (condition of rule.conditions; track $index) {
                          <div class="rule-condition">
                            @if (condition.logic_operator && $index > 0) {
                              <p>{{ condition.logic_operator }}</p>
                            }
                            <p class="rule-condition">
                              "{{ condition.column_name }} " {{ condition.operator.toUpperCase() }} "{{
                                condition.value
                              }}"
                            </p>
                            @if ($index === rule.conditions.length - 1) {
                              <mat-icon
                                aria-hidden="false"
                                aria-label="Example home icon"
                                fontIcon="arrow_right_alt"></mat-icon>
                              {{ getCollectionNameById(rule.target_collection_id) }}
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              } @empty {
                <p class="not-found-text labelHeading">No forwarding rules related to this collection</p>
              }
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
  </mat-sidenav>
  <div class="collections-container">
    <h1>Collections</h1>
    <div class="options-menu">
      <mat-form-field appearance="outline" color="accent" class="search-field" (click)="clearInputText()">
        <input
          type="text"
          placeholder="Select collection"
          matInput
          [matAutocomplete]="auto"
          [(ngModel)]="collectionInput"
          (input)="filterCollections($event)"
          (keydown.enter)="selectTopCollection($event)"
          #autocompleteTrigger="matAutocompleteTrigger" />
        <mat-autocomplete
          #auto="matAutocomplete"
          [displayWith]="displayFn.bind(this)"
          (optionSelected)="setCollection($event.option.value)">
          <mat-option *ngFor="let collection of filteredCollections" [value]="collection">
            {{ collection.name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <div class="right-options">
        <button mat-button (click)="openResearchPromptDialog()" [disabled]="!hasFilterOptions">
          <mat-icon>list</mat-icon>
          <span class="spacer"></span>
          Research
        </button>
        <button
          mat-button
          [disabled]="!hasFilterOptions"
          matTooltip="View research jobs"
          (click)="openViewResearchDialog()">
          <mat-icon>list</mat-icon>
          <span class="spacer"></span>
          View Research
        </button>
        <button mat-button (click)="openFilterModal()" [disabled]="!hasFilterOptions">
          <mat-icon>list</mat-icon>
          <span class="spacer"></span>
          Filters ({{ filterCount }})
        </button>
        <button mat-button (click)="openRules()">
          <mat-icon>assignment</mat-icon>
          Rules
        </button>
        <mat-form-field appearance="outline" color="accent" class="search-field">
          <mat-label>Search</mat-label>
          <input
            matInput
            matTooltip="Filter documents"
            placeholder="Search..."
            (input)="onQuickFilterChanged($event)" />
        </mat-form-field>
      </div>
    </div>
    <div class="table-container">
      <ag-grid-angular
        #agGrid
        [theme]="theme"
        style="height: 100%"
        [rowData]="filteredRowData"
        [pinnedTopRowData]="pinnedTopRows"
        [columnDefs]="colDefs"
        [animateRows]="true"
        [enableBrowserTooltips]="true">
      </ag-grid-angular>
    </div>
  </div>
</mat-sidenav-container>
